module.exports = __webpack_public_path__ + "img/sound-white.e300319f.svg";